<template>
  <div>
    <PageAllow controller="Waves" action="index" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-row dense class="mx-5">
        <v-col cols="12" sm="12" md="4">
          <v-row dense align="center" class="pa-1">
            <!-- <SearcherDatetimeRange
              type="datetime"
              v-model="datetimeRage"
              :label="$t('Wave.Fields.created_time')"
            /> -->
            <SearcherDatetimeRangeWithRadio
              v-model="options"
              type="datetime"
              show-radios
              :radios="datetimeRadios"
              removeIcon
            />
          </v-row>
        </v-col>
        <v-col cols="12" sm="12" md="8" align-self="center">
          <v-row dense align="center" class="search-controls">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-if="$permission.permissionAllow('Waves', 'add')"
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="px-0 py-0 caption font-weight-bold grey--text"
                  color="primary"
                  @click.stop="onSearch()"
                >
                  <v-icon small class="pe-1">fa-search</v-icon>
                  {{ $t("Search.search") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.searchTip") }}</span>
            </v-tooltip>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  text
                  class="caption font-weight-bold grey--text"
                  @click.stop="resetSearch()"
                >
                  <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                  {{ $t("Search.reset") }}
                </v-btn>
              </template>
              <span>{{ $t("Search.resetTip") }}</span>
            </v-tooltip>
            <v-divider vertical />
            <v-btn
              class="caption font-weight-bold grey--text"
              :class="
                $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
              "
              small
              text
              @click.stop="$store.commit('toggleSearchPanel')"
            >
              {{ $t("Search.pro") }}
              <v-icon small class="ps-1">{{
                $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
              }}</v-icon>
            </v-btn>
            <v-spacer />
            <v-btn
              v-if="$permission.permissionAllow('Waves', 'stockOrderList')"
              small
              color="primary"
              class="ms-1"
              @click.stop="generate()"
            >
              <v-icon x-small class="pe-1">fa-plus</v-icon>
              {{ $t("CRUD.newInfo", [$t("Wave.ObjectName")]) }}
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <v-expansion-panels
        v-model="$store.getters.panels"
        multiple
        flat
        accordion
      >
        <v-expansion-panel class="transparent-background-color">
          <v-expansion-panel-content>
            <v-row dense align="center">
              <v-col cols="12" sm="6" md="4">
                <SearcherStock
                  v-model="stocksSelected"
                  unclearable
                  :wmsSetting="[1]"
                  :stockTypes="[0]"
                />
              </v-col>
              <v-col
                v-if="settings && settings.stock_area_enable"
                cols="12"
                sm="6"
                md="4"
              >
                <SearcherStockArea
                  v-model="stockAreasSelected"
                  :stock-id="stock ? stock.id : 0"
                  :disabled="!stockAreaSetting"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherDistributionUser
                  v-model="distributionUserSelected"
                  :stockId="stock ? stock.id : 0"
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-select
                  v-model="stockOutTypeSelected"
                  :items="$consts.stock_out_order.types"
                  :label="$t('StockOrderOUT.Fields.stock_out_type')"
                >
                </v-select>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherDistrict v-model="districtSelected" />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherShop v-model="shopSelected" />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <SearcherMaterial
                  v-model="materialSelected"
                  :hint="$t('Wave.materialSelectedHint')"
                  errorHint
                />
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-select
                  v-model="waveRuleSelected"
                  :items="waveRules"
                  item-text="name"
                  item-value="id"
                  return-object
                  :label="$t('WaveRules.ObjectName')"
                >
                </v-select>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div class="mx-4 mb-4">
        <v-data-table
          v-model="showSelected"
          :headers="headers"
          :items="stock_order"
          :loading="loading"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          multi-sort
          show-select
          item-key="id"
          class="elevation-2 px-4 pt-1"
          :footer-props="footerProps"
        >
          <template v-slot:item.shop_name="{ item }">
            <span class="text-no-wrap">
              {{ item.shop_code }} / {{ item.shop_name }}
            </span>
          </template>
          <template v-slot:item.created="{ item }">
            {{ item.created | formatTime }}
          </template>
          <template v-slot:item.type="{ item }">
            {{ item.type | stockOrderOUTTypesText }}
          </template>
        </v-data-table>
      </div>
    </v-sheet>

    <v-dialog v-model="errorMaterialsDialog" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline" center>
            {{ $t("$vuetify.warning") }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="errorMaterialsDialog = false"
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("Wave.PickingFields.title")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-card-text>
          <v-container>
            <h3>{{ $t("Wave.errorMaterialsTitle") + $t("Global.colon") }}</h3>
            <v-list disabled>
              <v-list-item-group v-model="errorMaterials" color="primary">
                <v-list-item v-for="(item, i) in errorMaterials" :key="i">
                  <v-list-item-content>
                    <v-list-item-title>
                      {{ item.material_name }}
                      <span class="subtitle-2 ml-4">
                        {{
                          $t("Wave.DetailFields.position_available_quantity") +
                          $t("Global.colon")
                        }}
                        {{ item.material_num }}
                      </span>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-container>
          <v-card-subtitle>
            <h4>{{ $t("Wave.errorMateialsHint") }}</h4>
          </v-card-subtitle>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            outlined
            @click="errorMaterialsDialog = false"
            >{{ $t("$vuetify.close") }}</v-btn
          >
          <v-btn color="accent" @click="errMaterialDetails(1)">
            {{ $t("Wave.actions.editStockOutNum") }}
          </v-btn>
          <v-btn color="accent" @click="errMaterialDetails(2)">
            {{ $t("Wave.actions.stockOutPart") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ErrorMaterialDetailsDialog
      v-model="errorMaterialDetailsDialog"
      :errorMaterialDetails="errorMaterialDetails"
      :type="errorMaterialSolution"
      @removeOuts="removeOuts = $event"
      @addOuts="addOuts = $event"
      @recheckGenerate="$event == true ? generate() : ''"
      @refreshList="$event == true ? getStockOrderFromAPI() : ''"
    />
  </div>
</template>

<script>
import i18n from "@/i18n";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import { mapState } from "vuex";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherStock from "@/components/plugins/SearcherStock";
import SearcherStockArea from "@/components/plugins/SearcherStockArea";
import SearcherDistributionUser from "@/components/plugins/SearcherDistributionUser";
import SearcherShop from "@/components/plugins/SearcherShop";
import SearcherDistrict from "@/components/plugins/SearcherDistrict";
import SearcherMaterial from "@/components/plugins/SearcherMaterial";
import Waves from "@/api/waves";
import Stocks from "@/api/stocks";
import WaveRulers from "@/api/wave_rulers";
import ErrorMaterialDetailsDialog from "./plugins/ErrorMaterialDetailsDialog";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from:
    new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
      .toISOString()
      .substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  expect_time_from: "",
  expect_time_to: "",
  stock_id: 0,
  stock_area_id: null,
  type: 1,
  single_material: 1,
  distribution_user_id: null,
  material_id: null,
  city_1: "",
  shop_id: null,
};

export default {
  components: {
    PageAllow,
    Breadcrumbs,
    SearcherDatetimeRangeWithRadio,
    SearcherStock,
    SearcherDistributionUser,
    SearcherShop,
    SearcherDistrict,
    SearcherMaterial,
    SearcherStockArea,
    ErrorMaterialDetailsDialog,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        replace: true,
        href: "/home",
      },
      {
        text: i18n.t("Nav.stockManagement"),
        disabled: false,
        replace: true,
        href: "/stocks",
      },
      {
        text: i18n.t("Nav.waves"),
        disabled: false,
        href: "/waves",
      },
      {
        text: i18n.t("Nav.waveGenerate"),
        disabled: true,
        href: "/wave-generate",
      },
    ],
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("Wave.Fields.created_time"),
      },
      {
        key: "expect",
        text: i18n.t("Wave.Fields.expect_date"),
      },
    ],
    headers() {
      return [
        {
          text: i18n.t("Wave.DetailFields.wave_obj_name"),
          align: "start",
          sortable: false,
          value: "shop_name",
        },
        {
          text: i18n.t("Wave.DetailFields.stock_order_out_code"),
          align: "start",
          sortable: false,
          value: "stock_order_code",
        },
        {
          text: i18n.t("Wave.DetailFields.stock_area_name"),
          align: "start",
          sortable: false,
          value: "stock_area.area_name",
        },
        {
          text: i18n.t("Wave.DetailFields.stock_order_code"),
          align: "start",
          sortable: false,
          value: "order_code",
        },
        {
          text: i18n.t("Wave.DetailFields.stock_order_out_type"),
          align: "center",
          sortable: false,
          value: "type",
        },
        {
          text: i18n.t("Wave.DetailFields.stock_order_out_created_time"),
          align: "start",
          sortable: false,
          value: "created",
        },
      ];
    },
    footerProps() {
      var props = i18n.t("$config.footer-props");
      props.itemsPerPageOptions.push(300, -1);
      return props;
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    stock_order: [],
    showSelected: [],
    datetimeRage: [
      new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
        .toISOString()
        .substr(0, 10) + " 00:00:00",
      new Date().toISOString().substr(0, 10) + " 23:59:59",
    ],
    distributionUserSelected: null,
    stock: null,
    waveRules: [],
    waveRuleSelected: null,
    stockAreaSetting: false,
    stocksSelected: null,
    stockAreasSelected: null,
    stockOutTypeSelected: 1,
    districtSelected: null,
    shopSelected: null,
    materialSelected: null,
    options: JSON.parse(
      sessionStorage.getItem("wave-generate-options")
        ? sessionStorage.getItem("wave-generate-options")
        : JSON.stringify(defaultOptions)
    ),
    paging: {},
    errorMaterialsDialog: false,
    errorMaterials: null,
    errorMaterialDetailsDialog: false,
    errorMaterialDetails: null,
    errorMaterialSolution: 0,
    removeOuts: null,
    addOuts: null,
  }),

  mounted() {
    if (this.$route.query.stock_id) {
      this.stocksSelected = { id: this.$route.query.stock_id };
    }
    if (this.$route.query.type) {
      this.stockOutTypeSelected = this.$route.query.type;
    }
    this.$store.commit("openSearchPanel");
    this.$commonUtils
      .loadOptions("wave-generate", [
        "stocksSelected",
        "stockAreasSelected",
        "stockOutTypeSelected",
        "districtSelected",
        "shopSelected",
        "materialSelected",
      ])
      .then(
        function (data) {
          if (data.options) {
            this.options = data.options;
          } else this.resetSearch();

          data.selecteds.forEach((selected) => {
            switch (selected.key) {
              case "stocksSelected":
                this.stocksSelected = selected.value;
                break;
              case "stockAreasSelected":
                this.stockAreasSelected = selected.value;
                break;
              case "stockOutTypeSelected":
                this.stockOutTypeSelected = selected.value;
                break;
              case "districtSelected":
                this.districtSelected = selected.value;
                break;
              case "shopSelected":
                this.shopSelected = selected.value;
                break;
              case "materialSelected":
                this.materialSelected = selected.value;
                break;
            }
          });
        }.bind(this)
      );
  },

  methods: {
    resetSearch() {
      this.stocksSelected = null;
      this.stockAreasSelected = null;
      this.stockOutTypeSelected = 1;
      this.districtSelected = null;
      this.shopSelected = null;
      this.materialSelected = null;
      this.datetimeRage = [
        new Date(new Date().getTime() - 30 * 24 * 3600 * 1000)
          .toISOString()
          .substr(0, 10) + " 00:00:00",
        new Date().toISOString().substr(0, 10) + " 23:59:59",
      ];
      this.options = JSON.parse(JSON.stringify(defaultOptions));
    },
    onSearch() {
      this.getStockOrderFromAPI();
    },
    getStockOrderFromAPI() {
      var options = JSON.parse(JSON.stringify(this.options));
      Waves.stockOrderList(
        Object.assign({}, options, {
          itemsPerPage:
            options.itemsPerPage == -1
              ? this.$consts.limitAll
              : options.itemsPerPage,
        })
      ).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.stock_order = response.data.stock_order;
            this.paging = response.data.paging;
            //设置默认选中单据
            if (this.paging.page == 1)
              if (this.stock_order.length && this.stock.wave_order_num) {
                this.showSelected = this.stock_order.slice(
                  0,
                  this.stock.wave_order_num
                );
              } else {
                this.showSelected = [];
              }
          } else if (response.data.error.code.isNoResultSet()) {
            this.options.page = 1;
          }
        }.bind(this)
      );
    },
    generate() {
      if (this.showSelected.length) {
        var showSelectedId = [];
        this.showSelected.map((selected) => {
          showSelectedId.push(selected.id);
        });

        Waves.add({
          stock_order_id: showSelectedId,
          stock_id: this.stocksSelected ? this.stocksSelected.id : "",
          stock_area_id:
            this.stockAreaSetting && this.stockAreasSelected
              ? this.stockAreasSelected.id
              : 0,
          type: this.stockOutTypeSelected,
          distribution_user_id: this.distributionUserSelected
            ? this.distributionUserSelected.id
            : "",
          wave_ruler_id: this.waveRuleSelected ? this.waveRuleSelected.id : 0,
        }).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.$router.push(
                "/waves?stock_id=" +
                  (this.stocksSelected ? this.stocksSelected.id : 0) +
                  "&stock_area_id=" +
                  (this.stockAreaSetting && this.stockAreasSelected
                    ? this.stockAreasSelected.id
                    : 0)
              );
            } else if (response.data.error_material) {
              this.errorMaterialsDialog = true;
              this.errorMaterials = response.data.error_material;
            }
          }.bind(this)
        );
      }
    },
    //获取不能生成波次的出库详情
    errMaterialDetails(type) {
      //获取所选择的出库单id
      var showSelectedId = [];
      this.showSelected.map((selected) => {
        showSelectedId.push(selected.id);
      });
      //获取库位数量不足的商品id
      var errMaterialIds = Object.keys(this.errorMaterials);
      Waves.getErrMaterialOutDetail({
        stock_order_ids: showSelectedId,
        material_ids: errMaterialIds,
      }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.errorMaterialDetails = response.data.material_out_details;
            this.errorMaterialDetails.forEach((materialDetail) => {
              materialDetail.stock_out_real_count = 0;
              materialDetail.out_details.forEach((detail) => {
                materialDetail.stock_out_real_count += Number(
                  detail.default_confirm_num
                );
                detail.edit_confirm_num = detail.confirm_num;
              });
            });
            this.errorMaterialDetailsDialog = true;
            this.errorMaterialSolution = type;
            this.errorMaterialsDialog = false;
          }
        }.bind(this)
      );
    },
  },

  watch: {
    options: {
      deep: true,
      handler() {
        if (this.options.datetimeRadioSelected == "created") {
          this.options.date_from = this.options.created_time_from;
          this.options.date_to = this.options.created_time_to;
          if (this.options.date_type) {
            delete this.options.date_type;
          }
        } else if (this.options.datetimeRadioSelected == "expect") {
          this.options.date_from = this.options.expect_time_from;
          this.options.date_to = this.options.expect_time_to;
          this.options.date_type = 1;
        }
        this.getStockOrderFromAPI();
        sessionStorage.setItem(
          "wave-generate-options",
          JSON.stringify(this.options)
        );
      },
    },
    stockOutTypeSelected: {
      handler() {
        this.options.type = this.stockOutTypeSelected
          ? this.stockOutTypeSelected
          : "";
        sessionStorage.setItem(
          "wave-generate-stockOutTypeSelected",
          JSON.stringify(this.stockOutTypeSelected)
        );
      },
    },
    stocksSelected: {
      deep: true,
      handler() {
        if (this.stocksSelected) {
          this.options.stock_id = this.stocksSelected.id;
          //获取仓库详情
          Stocks.fetchOne(this.stocksSelected.id).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.stock = response.data.stock;
                //设置默认选中单据
                if (this.paging.page == 1)
                  if (
                    this.stock_order.length &&
                    this.stocksSelected.wave_order_num
                  ) {
                    this.showSelected = this.stock_order.slice(
                      0,
                      this.stock.wave_order_num
                    );
                  } else {
                    this.showSelected = [];
                  }
              }
            }.bind(this)
          );
          //获取波次策略
          WaveRulers.fetch({ stock_id: this.stocksSelected.id }).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.waveRules = response.data.wave_rulers;
              }
            }.bind(this)
          );
          if (this.stocksSelected.stock_area) {
            this.stockAreaSetting = true;
          } else {
            this.stockAreaSetting = false;
          }
        } else {
          this.options.stock_id = "";
        }
        sessionStorage.setItem(
          "wave-generate-stocksSelected",
          JSON.stringify(this.stocksSelected)
        );
      },
    },
    stockAreasSelected: {
      handler() {
        this.options.stock_area_id = this.stockAreasSelected
          ? this.stockAreasSelected.id
          : 0;
        sessionStorage.setItem(
          "wave-generate-stockAreasSelected",
          JSON.stringify(this.stockAreasSelected)
        );
      },
    },
    distributionUserSelected: {
      handler() {
        this.options.distribution_user_id = this.distributionUserSelected
          ? this.distributionUserSelected.id
          : "";
        sessionStorage.setItem(
          "wave-generate-distributionUserSelected",
          JSON.stringify(this.distributionUserSelected)
        );
      },
    },
    materialSelected: {
      handler() {
        this.options.material_id = this.materialSelected
          ? this.materialSelected.id
          : "";
        sessionStorage.setItem(
          "wave-generate-materialSelected",
          JSON.stringify(this.materialSelected)
        );
      },
    },
    districtSelected: {
      handler() {
        this.options.city_1 = this.districtSelected
          ? this.districtSelected.code
          : "";
        sessionStorage.setItem(
          "wave-generate-districtSelected",
          JSON.stringify(this.districtSelected)
        );
      },
    },
    shopSelected: {
      handler() {
        this.options.shop_id = this.shopSelected ? this.shopSelected.id : "";
        sessionStorage.setItem(
          "wave-generate-shopSelected",
          JSON.stringify(this.shopSelected)
        );
      },
    },
    removeOuts: {
      handler() {
        if (this.removeOuts.length) {
          this.removeOuts.forEach((remove_id) => {
            this.showSelected.forEach((item) => {
              if (item.id == remove_id) {
                this.showSelected.splice(this.showSelected.indexOf(item), 1);
              }
            });
          });
        }
      },
    },
    addOuts: {
      handler() {
        if (this.addOuts.length) {
          this.addOuts.forEach((add_id) => {
            this.showSelected.push({ id: add_id });
          });
        }
      },
    },
  },
};
</script>